import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { CheckCircle, Search, TrendingUp } from "lucide-react";
const steps = [{
  id: 1,
  title: "Workflow Review",
  description: "Comprehensive analysis of your current operational processes, systems, and vendor relationships to understand the full picture.",
  icon: Search
}, {
  id: 2,
  title: "Bottleneck Identification",
  description: "Pinpoint inefficiencies, communication gaps, and process constraints that are limiting your productivity and growth.",
  icon: CheckCircle
}, {
  id: 3,
  title: "Actionable Proposals",
  description: "Receive detailed improvement recommendations with implementation support to boost efficiency and reduce operational costs.",
  icon: TrendingUp
}];
export default function OurStreamlinedAuditProcess() {
  return <section className="bg-background py-16 px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mx-auto mb-12 max-w-3xl text-center">
          <h2 className="mb-4 font-display text-4xl font-bold leading-tight text-foreground">
            Our Streamlined Audit Process
          </h2>
          <p className="text-lg text-muted-foreground">
            Aran Group delivers systematic operational efficiency audits designed to uncover hidden opportunities for productivity gains and cost reduction.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {steps.map((step, i) => {
          const IconComponent = step.icon;
          return <Card key={step.id} data-index={i} className="card border border-border bg-background px-6 shadow-soft transition-all duration-[250ms] ease-[cubic-bezier(0.22,1,0.36,1)] hover:-translate-y-1 hover:shadow-medium animate-fade-in-up" style={{
            animationDelay: `${i * 100}ms`
          }}>
                <CardHeader className="px-0">
                  <div className="mb-4 inline-flex size-14 items-center justify-center rounded-lg bg-primary/10">
                    <IconComponent className="size-7 text-primary" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-xl font-semibold text-foreground">
                    {step.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="px-0">
                  <CardDescription className="text-base leading-relaxed text-muted-foreground">
                    {step.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>

        <div className="mt-12 text-center">
          <Link to="/ContactPage">
            <Button size="lg" className="btn-primary inline-flex items-center justify-center gap-2 rounded-md bg-primary px-8 py-3 font-semibold text-primary-foreground shadow-soft transition-all duration-[250ms] ease-[cubic-bezier(0.34,1.56,0.64,1)] hover:-translate-y-0.5 hover:bg-primary-hover hover:shadow-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring active:translate-y-0 active:bg-primary-active">
              Start Your Audit
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}